export default "__VITE_ASSET__CVeW4GeI__"